// extracted by mini-css-extract-plugin
export var container = "_5d-0";
export var icon = "_5d-1";
export var text = "_5d-2";